module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeline"
  }, [_c('timeline-separator'), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-530760e5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Timeline/Timeline.vue
// module id = 297
// module chunks = 1